import z from 'zod';

export type ApiKeyFormSchemaValues = z.infer<typeof apiKeyFormSchema>;

export const apiKeyFormSchema = z.object({
    name: z.string().max(50),
});
